// === WORKFLOW RESET ===
// "Nieuwe aanvraag": the page-refresh reset without the refresh. Everything a finished (or
// abandoned) aanvraag left in sessionStorage goes, so the next one starts from a clean slate:
// the offer-chain ids and flags (summary/sessionState), the per-relation submitted/email markers,
// the Infofolio caches and the screen-local price caches and payload fingerprints. The workflow
// CONTEXT (selection, step data, relation, payment, shared slices) is core's clearWorkflowData;
// callers run that right after this.
import { INFOFOLIO_SESSION_KEYS } from './addressSharing';
import { clearAllChainState, getQuoteId, getVpIdnr, requestSubmittedKey } from '../pages/screens/summary/sessionState';
import { PROGRESS_FRONTIER_KEYS } from './progressFrontier';

/** Screen-local sessionStorage keys, written by literal name in their own screens. */
export const SCREEN_SESSION_KEYS = [
  'request_id',
  PROGRESS_FRONTIER_KEYS.quote,
  PROGRESS_FRONTIER_KEYS.application,
  // Written by the Confirmation screen for the dev debug panel. Without these the panel keeps
  // showing the PREVIOUS aanvraag's createRequest after "Nieuwe aanvraag" — confusing while
  // debugging the very flow this button exists for.
  'debug_create_request',
  'debug_create_response',
  'woonhuis_monument_property',
  'inboedel_monument_property',
  'personenauto_variant_premiums',
  'rechtsbijstand_coverage_prices',
  'inboedel_coverage_prices',
  'rechtsbijstand_final_payload',
  'inboedel_final_payload',
  'woonhuis_final_payload',
  'personenauto_final_payload',
] as const;

export const clearSaaSessionState = (): void => {
  if (typeof sessionStorage === 'undefined') return;
  const vpIdnr = getVpIdnr();
  const quoteId = getQuoteId();
  if (vpIdnr && quoteId) {
    sessionStorage.removeItem(requestSubmittedKey(vpIdnr, quoteId));
    sessionStorage.removeItem(`email_sent_${vpIdnr}_${quoteId}`);
  }
  clearAllChainState();
  for (const key of [...INFOFOLIO_SESSION_KEYS, ...SCREEN_SESSION_KEYS]) sessionStorage.removeItem(key);
};
